import React from 'react';
import {Card} from "antd";
import {compose} from "redux";
import {connect} from "react-redux";
import {withLoading} from "../../Boilerplate/deferLoaderHoc";
import {SubmittalForm} from "./SubmittalForm";
import {getSubmittal, updateSubmittal} from "../../../actions/submittals";

const SubmittalEdit = props => {
  const { submittal, projectid, onSubmit, onCancel } = props;
  return <Card title='Submittal Details' className={'edit-view'}>
    <SubmittalForm projectid={projectid} submittal={submittal} onCancel={onCancel} onSubmit={onSubmit}/>
  </Card>;
};

export default compose(
  connect(
    (state, props) => {
      let submittal = state.view.subview.data[props.match.params.submittalId];
      if (!submittal) return { loading: true };
      return { submittal: submittal.resource, projectid: props.match.params.id };
    },
    (dispatch, props) => ({
      loader: () => dispatch(getSubmittal(props.match.params.id, props.match.params.submittalId)),
      onSubmit: (submittal) => {
        dispatch(updateSubmittal(props.match.params.id, submittal));
        props.history.goBack();
      },
      onCancel: () => props.history.goBack()
    })
  ),
  withLoading
)(SubmittalEdit);



// WEBPACK FOOTER //
// ./src/components/Projects/Submittals/SubmittalEdit.js